import Vue from 'vue';
export default {
  data() {
    return {
      activeTab: 1,
      divider1: 'text-index tab-divider-active',
      divider2: 'text-index tab-divider-notload',
      divider3: 'text-index tab-divider-notload',
      showUserBrithDate: false,
      showUserExpireDate: false,
      tempUserExpireDate: '',
      tempUserBrithDate: '',
      passwordIcon: 'mdi-eye',
      passwordClass: 'password',
      repeatPasswordIcon: 'mdi-eye',
      repeatPasswordClass: 'password',
      maxDate: '',
      minDate: '1900/05/20',
      expireMaxDate: '',
      expireMinDate: '',
      allUserRoles: [],
      allUserSelectedRoles: [],
      allUserPermissions: [],
      allUserSelectedPermissions: [],
    };
  },
  methods: {
    changeStep: function (step) {
      if (step == 2) {
        this.checkStepOneValdition();
      } else if (step == 3) {
        this.checkStepTowValdition();
      } else if (step == 4) {
        this.checkStepTreeValdition();
      }
    },
    backToStepOne: function () {
      this.activeTab = 1;
      this.divider1 = 'text-index tab-divider-active';
      this.divider2 = 'text-index tab-divider-notload';
      this.divider3 = 'text-index tab-divider-notload';
    },
    backToStepTow: function () {
      this.activeTab = 2;
      this.divider1 = 'text-index tab-divider-finish';
      this.divider2 = 'text-index tab-divider-active';
      this.divider3 = 'text-index tab-divider-notload';
    },
    backToStepTree: function () {
      this.activeTab = 3;
      this.divider1 = 'text-index tab-divider-finish';
      this.divider2 = 'text-index tab-divider-finish';
      this.divider3 = 'text-index tab-divider-active';
    },
    checkStepOneValdition: function () {
      if (!this.user.firstName) {
        this.snackText = 'لطفا نام را وارد نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.user.lastName) {
        this.snackText = 'لطفا نام خانوادگی را وارد نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.user.nationalCode) {
        this.snackText = 'لطفا کد ملی را وارد نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.user.nationalCode.length < 10) {
        this.snackText = 'کد ملی وارد شده معتبر نیست.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.user.phoneNumber) {
        if (this.user.phoneNumber.length < 11) {
          this.snackText = 'شماره همراه وارد شده معتبر نیست.';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      }
      if (!this.user.userPersonnelInfo.organizationRoleId) {
        this.snackText = 'لطفا سمت را وارد نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.user.userPersonnelInfo.personnelNumber) {
        this.snackText = 'لطفا شماره پرسنلی را وارد نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.user.userCityIds.length == 0) {
        this.snackText = 'لطفا شهرستان را وارد نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.user.userName) {
        this.snackText = 'لطفا نام کاربری را وارد نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.user.password) {
        this.snackText = 'لطفا کلمه عبور را وارد نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.user.passwordRepeat) {
        this.snackText = 'لطفا تکرار کلمه عبور را وارد نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.user.passwordRepeat != this.user.password) {
        this.snackText = 'کلمه عبور با تکرار آن برابر نیست.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      this.activeTab = 2;
      this.divider1 = 'text-index tab-divider-finish';
      this.divider2 = 'text-index tab-divider-active';
      this.divider3 = 'text-index tab-divider-notload';
    },
    checkStepTowValdition: function () {
      //هیچ کدام از موارد قدم 2 اجباری نیست
      this.activeTab = 3;
      this.divider1 = 'text-index tab-divider-finish';
      this.divider2 = 'text-index tab-divider-finish';
      this.divider3 = 'text-index tab-divider-active';
    },
    checkStepTreeValdition: function () {
      if (this.allUserSelectedRoles.length == 0) {
        this.snackText = 'لطفا نقش را وارد نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      this.activeTab = 4;
      this.divider1 = 'text-index tab-divider-finish';
      this.divider2 = 'text-index tab-divider-finish';
      this.divider3 = 'text-index tab-divider-finish';
    },
    showPassword: function () {
      if (this.passwordIcon == 'mdi-eye') {
        this.passwordIcon = 'mdi-eye-off';
        this.passwordClass = '';
      } else if (this.passwordIcon == 'mdi-eye-off') {
        this.passwordIcon = 'mdi-eye';
        this.passwordClass = 'password';
      }
    },
    showRepeatPassword: function () {
      if (this.repeatPasswordIcon == 'mdi-eye') {
        this.repeatPasswordIcon = 'mdi-eye-off';
        this.repeatPasswordClass = '';
      } else if (this.repeatPasswordIcon == 'mdi-eye-off') {
        this.repeatPasswordIcon = 'mdi-eye';
        this.repeatPasswordClass = 'password';
      }
    },
    userBrithDateChange: function () {
      if (this.user.birthDate) {
        this.tempUserBrithDate = Vue.moment(this.user.birthDate).format('jYYYY-jMM-jDD');
      }
    },
    userExpireDateChange: function () {
      if (this.user.expireDate) {
        this.tempUserExpireDate = Vue.moment(this.user.expireDate).format('jYYYY-jMM-jDD');
      }
    },
    defineRoles: function (roles) {
      this.allUserRoles = roles;
    },
    addRoleToUserRoles: function (role) {
      this.allUserSelectedRoles.push(role);
      for (let i = 0; i < this.allUserRoles.length; i++) {
        if (role.id == this.allUserRoles[i].id) {
          this.allUserRoles.splice(i, 1);
          break;
        }
      }
    },
    removeRoleFromUserRoles: function (role) {
      this.allUserRoles.push(role);
      for (let i = 0; i < this.allUserSelectedRoles.length; i++) {
        if (role.id == this.allUserSelectedRoles[i].id) {
          this.allUserSelectedRoles.splice(i, 1);
          break;
        }
      }
    },
    definePermissions: function (permissions) {
      this.allUserPermissions = permissions;
    },
    addPermissionToUserPermissions: function (permission) {
      this.allUserSelectedPermissions.push(permission);
      for (let i = 0; i < this.allUserPermissions.length; i++) {
        if (permission.id == this.allUserPermissions[i].id) {
          this.allUserPermissions.splice(i, 1);
          break;
        }
      }
    },
    removePermissionFromUserPermissions: function (permission) {
      this.allUserPermissions.push(permission);
      for (let i = 0; i < this.allUserSelectedPermissions.length; i++) {
        if (permission.id == this.allUserSelectedPermissions[i].id) {
          this.allUserSelectedPermissions.splice(i, 1);
          break;
        }
      }
    },
    backToUsers: function () {
      this.$router.push({ name: 'user' });
    },
    clearBirthDate: function () {
      this.showUserBrithDate = false;
      this.tempUserBrithDate = '';
      this.user.birthDate = '';
    },
    clearExpireDate: function () {
      this.showUserExpireDate = false;
      this.tempUserExpireDate = '';
      this.user.expireDate = '';
    },
  },
};
